// -- WARNING --
// -- Do not change the values in this file. --
//
// These values form the dedicated and required JSONP callback
//   names for each form page, and are hardcoded into the
//   Pardot .js files. A change in any of these strings will
//   break the EnrollmentForm, unless they are simulataneously
//   reflected in the Pardot `form_name_success.js` AND
//   `form_name_error.js` files.
const ApplyPageForm = 'ApplyPage';
const CallbackSuffix = 'Callback';
const DataScience = 'DataScience';
const Design = 'Design';
const EducationEmployment = 'EducationEmployment';
const EqualEmploymentOpportunity = 'EqualEmploymentOpportunity';
const JobProfile = 'JobProfile';
const JobSearch = 'JobSearch';
const Marketing = 'Marketing';
const Sales = 'Sales';
const PathriseQuestions = 'PathriseQuestions';
const PrimaryTrack = 'PrimaryTrack';
const ProductStrategyOperations = 'ProductStrategyOperations';
const ResumeUpload = 'ResumeUpload';
const SecondaryTrack = 'SecondaryTrack';
const SoftwareEngineering = 'SoftwareEngineering';
const WebDevelopment = 'WebDevelopment';

export {
  ApplyPageForm,
  CallbackSuffix,
  DataScience,
  Design,
  EducationEmployment,
  EqualEmploymentOpportunity,
  JobProfile,
  JobSearch,
  Marketing,
  Sales,
  PathriseQuestions,
  PrimaryTrack,
  ProductStrategyOperations,
  ResumeUpload,
  SecondaryTrack,
  SoftwareEngineering,
  WebDevelopment,
};
